import Capitalize from '../helpers/Capitalize';

const isValidATCForm = (productOptions, ProductOptionsMessages) => {
    const result = {
        invalid: false,
        messages: [],
    };

    if (
        productOptions.dimensions &&
        productOptions.optionsSelected &&
        productOptions.dimensions.length !== productOptions.optionsSelected.length
    ) {
        const selectedOptionsTypes = productOptions.optionsSelected.map((option) => option.type);
        result.messages = [
            ...result.messages,
            ...productOptions.dimensions
                .filter((dimension) => !selectedOptionsTypes.includes(dimension.id))
                .map(({ id }) => ({
                    section: id,
                    message: {
                        id: `${id}MessageId`,
                        title: ProductOptionsMessages.requiredFieldMessage.replace(
                            '$1',
                            Capitalize.toCapitalize(id)
                        ),
                    },
                })),
        ];
    }

    return result;
};

const validateAddToCartForm = (productOptions, ProductOptionsMessages) => {
    // List of validations here...
    const requiredFields = isValidATCForm(productOptions, ProductOptionsMessages); // this.validateRequiredFields();

    return {
        invalid:
            [requiredFields.messages].some((arr) => arr.length > 0) ||
            [requiredFields.invalid].some((invalid) => invalid === true),
        messages: [...requiredFields.messages],
    };
};

export default validateAddToCartForm;
